import { render, staticRenderFns } from "./pop-pyramid.vue?vue&type=template&id=fee3c7ac&"
import script from "./pop-pyramid.vue?vue&type=script&lang=js&"
export * from "./pop-pyramid.vue?vue&type=script&lang=js&"
import style0 from "./pop-pyramid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fee3c7ac', component.options)
    } else {
      api.reload('fee3c7ac', component.options)
    }
    module.hot.accept("./pop-pyramid.vue?vue&type=template&id=fee3c7ac&", function () {
      api.rerender('fee3c7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/pop-pyramid.vue"
export default component.exports